import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import {Divider, Layout, Typography, Table, Tooltip} from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { iconMapping } from '../../configs/AppsConfig';

import PortfoliosTable from './PortfoliosCollection/components/PortfoliosTable';
import PageHeader from '../../layouts/PageHeader';
import Placeholder from "../../components/Placeholder";
import NavTrail from "../../layouts/NavTrail";
import { selectPortfoliosWithUserUpdates } from "../../store/slices/portfolios.slice";
import { selectUserFields } from '../../store/slices/user.slice';
import usePortfoliosCollection from "./PortfoliosCollection/usePortfoliosCollection";
import useCompany from "../Company/useCompany";

import { commonTableColumns } from './PortfoliosCollection/components/tableConfig';


const ClientPortfolios = () => {
    const { clientFilteredPortfolios } = usePortfoliosCollection();
    const isLoading = useSelector((state) => state.portfolios.loading);
    console.log(clientFilteredPortfolios)

    const columns = [
        {
            title: "Client",
            dataIndex: ['properties', 'preferences', 'info', 'name'],
            key: "clientName",
            searchable: true,
            onFilter: (value, record) => record.properties.preferences.info.name.toLowerCase().includes(value.toLowerCase()),

        },
        {
            title: "Risk Score",
            dataIndex: ['properties', 'preferences', 'info', 'riskalyzeScore'],
            key: "riskScore",
            sorter: (a, b) => a.properties.preferences.info.riskalyzeScore - b.properties.preferences.info.riskalyzeScore,

        },
        {
            title: "Initial Capital",
            dataIndex: ['properties', 'preferences', 'info', 'initialValue'],
            key: "initialCapital",
            sorter: (a, b) => a.properties.preferences.info.initialValue - b.properties.preferences.info.initialValue,

        },
        {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => (
                    <Tooltip title={text}>
                        <span className={'line-clamp-2 max-w-[200px] font-medium'}>
                            {text}
                        </span>
                    </Tooltip>
                ),
                onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
                searchable: true
        },
        ...commonTableColumns({benchmarkTickers: null, showTargets: false}),
    ];

    // const portfolioPrefix = useSelector((state) => selectUserFields(state, 'settings.portfolio_prefix'));

    if (isLoading) return <Placeholder text="Loading portfolios..." />;
    const trailItems = [
        {label: "Portfolios", path: "/portfolios"},
        {label: "Client Portfolios"}
    ];
    return (
          <Layout>
              <NavTrail items={trailItems} />
              <Layout.Content className={'p-8'}>
                  <Table
                      dataSource={clientFilteredPortfolios}
                      columns={columns}
                      className="nowrap-headers"
                      rowKey="id"
                      pagination={{ pageSize: 100 }}
                      style={{ fontSize: '11px' }}
                      scroll={{ y: 800, x: 'max-content' }}
                    />
              </Layout.Content>

          </Layout>
  );
};

export default ClientPortfolios;